export class Global {
  // baseUrl = 'http://NJBAPI.courierpro.co.in/api/';
  baseUrl = 'https://api.njbworldwide.com/api/';
  //baseUrl = 'http://localhost:49528/api/';
}
